import {
  SET_TRAFFIC,
  SET_SHOW_CLOSED_SIG_EVENTS,
  SET_DEFAULT_BASEMAP,
  SET_INCIDENT_DISPLAY_ORDER,
  SET_SIG_EVENT_DISPLAY_ORDER,
  SET_TIMESTAMP_FORMAT,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_FAILURE,
} from './actionTypes'
import { BASE_URL } from '../constants'

export const setTraffic = (token, value) => {
  fetch(`${BASE_URL}api/preferences/show_traffic`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(value),
  })
  return {
    type: SET_TRAFFIC,
    value,
  }
}

export const setShowClosedSigEvents = (token, value) => {
  fetch(`${BASE_URL}api/preferences/show_closed_sigevents`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(value),
  })
  return {
    type: SET_SHOW_CLOSED_SIG_EVENTS,
    value,
  }
}

export const setDefaultBasemap = (token, value) => {
  fetch(`${BASE_URL}api/preferences/default_basemap`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(value),
  })
  return {
    type: SET_DEFAULT_BASEMAP,
    value,
  }
}

export const setIncidentDisplayOrder = (token, value) => {
  fetch(`${BASE_URL}api/preferences/incident_order`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(value),
  })
  return {
    type: SET_INCIDENT_DISPLAY_ORDER,
    value,
  }
}

export const setSigEventDisplayOrder = (token, value) => {
  fetch(`${BASE_URL}api/preferences/sigevent_order`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(value),
  })
  return {
    type: SET_SIG_EVENT_DISPLAY_ORDER,
    value,
  }
}

export const setTimestampFormat = (token, value) => {
  fetch(`${BASE_URL}api/preferences/timestamp_format`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(value),
  })
  return {
    type: SET_TIMESTAMP_FORMAT,
    value,
  }
}

export const fetchSuccess = (preferences) => ({
  type: FETCH_SUCCESS,
  preferences,
})

export const fetchStart = () => ({
  type: FETCH_START,
})

export const fetchFail = (error) => ({
  type: FETCH_FAILURE,
  error,
})
